// extracted by mini-css-extract-plugin
module.exports = {"timezoneNote":"channel-history_timezoneNote_1P3K1"};